export const checkColumnValue = (checked, locationId, urgencyKey, subscriptions, eventsKeys) => {
  if (!checked) {
    return 0;
  } else {
    return +!eventsKeys.some((eventKey) => !subscriptions[eventKey]?.[locationId]?.urgencies[urgencyKey]);
  }
};
